import gql from 'graphql-tag';

const SUGGEST_PRICE = gql`
  mutation suggestPrice($input: SuggestPriceInput!) {
    suggestPrice(input: $input)
  }
`;

const suggestPrice = client => input =>
  client.mutate({
    mutation: SUGGEST_PRICE,
    variables: { input }
  });

export default suggestPrice;
